export const cardConfig = {
  iconTypes: {
    DOC: 'doc',
    DOCX: 'docx',
    DOCM: 'docm',
    DOTX: 'dotx',
    WORDML: 'wordml',
    XLS: 'xls',
    XLSX: 'xlsx',
    XLSM: 'xlsm',
    XLSB: 'xlsb',
    XLTM: 'xltm',
    PPT: 'ppt',
    PPTX: 'pptx',
    PPTM: 'pptm',
    PPSX: 'ppsx',
    PDF: 'pdf',
    PNG: 'png',
    JPG: 'jpg',
    GIF: 'gif',
    JPEG: 'jpeg',
    DOCUMENT: 'Document',
    CREDENTIAL: 'Credential',
    VIDEO: 'Video',
    AUDIO: 'Audio',
    DataVis: 'DataVis'
  },
  fileTypesName: {
    Word: 'Word document',
    PowerPoint: 'PowerPoint document',
    Excel: 'Excel document',
    PDF: 'PDF document',
    Image: 'Image document'
  },
  contentTypes: {
    EYKnowledgeDocument: 'EY Knowledge Document',
    EYVideo: 'EY Video',
    EYMethodDocument: 'EY Method Document',
    EYKnowledgePage: 'EY Knowledge Page',
    EYTopicPage: 'EY Topic Page',
    EYKnowledgeFoPPage: 'EY Knowledge FoP Page',
    EYKnowledgeMethodPage: 'EY Knowledge Method Page',
    EYKnowledgeSolutionPage: 'EY Knowledge Solution Page',
    EYKnowledgePolicyDocument: 'EY Knowledge Policy Document',
    EYPolicyDocument: 'Policy Document',
    EYKnowledgeBuyerPage: 'EY Knowledge Buyer Page',
    EYTasPolicyPage: 'EY Tas Policy Page',
    EYKnowledgePolicyPage: 'EY Knowledge Policy Page',
    EYCredentialListItem: 'EY Credential List Item',
    DataProvider: 'Data Provider',
    DataAsset: 'Data Asset',
    EYPolicyPage: 'EY Policy Page',
    EYPolicyGuidancePage: 'EY Policy Guidance Page',
    EYDataVisualization: 'EY Data Visualization',
    EYPPerspectiveDocument: 'EY-P Perspective Document',
    EYPEngagementItem: 'EY-P Engagement item',
    EYResourceCatalogueItem: 'EY Resource Catalogue item',
    NewsArticle: 'Intranet News Article',
    NewsVideo: 'Intranet News Video',
    NewsPage: 'Intranet Content Page'
  },

  credentialConfidentialityLevels: {
    Level1: 'Level 1 - No restriction',
    Level2: 'Level 2 - Client name confidential (restricted)',
    Level3: 'Level 3 - Client name strictly confidential'
  },
  AEMLevels: {
    AEMLevel1: 'Level-1',
    AEMLevel2: 'Level-2',
    AEMLevel3: 'Level-3'
  },

  dataAssetLicenseStatus: {
    ExpiringSoon: 'EXPIRING SOON',
    Internal: 'INTERNAL',
    LicensedRestricted: 'LICENSED - RESTRICTED',
    LicensedGlobalEnterprise: 'LICENSED - GLOBAL ENTERPRISE',
    LicenseNotRequired: 'LICENSE NOT REQUIRED',
    ExpiredLicense: 'EXPIRED LICENSE',
    OpenSource: 'OPEN SOURCE',
    Unlicensed: 'UNLICENSED',
    OpenData: 'OPEN DATA',
    ExtLicenseRestricted: 'EXTERNAL LICENSE - RESTRICTED',
    ExtLicenseGlobal: 'EXTERNAL LICENSE - GLOBAL',
    ExtLicenseDerived: 'EXTERNAL LICENSE - DERIVED',
    ExtUnlicensed: 'EXTERNAL UNLICENSED',
    InternalReference: 'INTERNAL REFERENCE',
    InternalInsights: 'INTERNAL INSIGHTS',
    InternalSurvey: 'INTERNAL SURVEY',
    InternalProduct: 'INTERNAL PRODUCT'
  },

  cardTypes: {
    Documents: 'Document',
    Credentials: 'Credential',
    Videos: 'Video',
    BBFoP: 'Page | BBFoP',
    Solutions: 'Page | Solution',
    Policies: 'Document | Policy',
    Method: 'Document | Method',
    Data: 'Data',
    FieldsOfPlay: 'Page | Fields of Play',
    People: 'People',
    PagePolicies: 'Page | Policy',
    BuyerPage: 'Page | Buyer',
    KnowledgePage: 'Page',
    DocumentVis: 'Document | Data Vis',
    EYPEngagement: 'EY-P | Engagement', // Added for EY-P
    EYPPerspective: 'EY-P | Perspective', // Added for EY-P
    Site: 'Site',
    News: 'News',
    NewsArticle: 'News | Article',
    PageIntranet: 'Page | Intranet',
    NewsVideo: 'News | Video',
    SiteSharepoint: "Site | SharePoint"
  },
  solutionTypes: {
    Solution: 'Solution',
    NewSolution: 'New Solution',
    FieldOfPlay: 'Field of Play',
    BBFOP: 'bbfop',
    Buyer: 'buyer'
  },

  DocumentEllipse: {
    ShareLink: 'Share link',
    Download: 'Download'
  },
  CredentialEllipse: {
    ShareLink: 'Share link',
    PowerPoint: 'Export to Powerpoint',
    AddToExpCart: 'Add to Export Cart',
    Excel: 'Export to Excel'
  },
  DataEllipse: {
    ShareLink: 'Share link'
  },
  PeopleEllipse: {
    ShareLink: 'Share link',
    Outlook: 'Send email',
    Teams: 'Chat in teams'
  },
  VideoEllipse: {
    ShareLink: 'Share link'
  },
  EYPublicAccessType: 'public'
};
